// extracted by mini-css-extract-plugin
module.exports = {"cartCardText":"IXOJZBKr","discountTag":"gCzdaFlH"};